import { render } from "./labs.vue?vue&type=template&id=9c355b8c&scoped=true"
import script from "./labs.vue?vue&type=script&lang=js"
export * from "./labs.vue?vue&type=script&lang=js"

import "./labs.vue?vue&type=style&index=0&id=9c355b8c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c355b8c"]])

export default __exports__